// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__41i26","footer":"NavbarSimple_footer__Z8s37","link":"NavbarSimple_link__AaoSt","linkIcon":"NavbarSimple_linkIcon__fiDhR"};